<template>
  <el-card>
    <div slot="header" class="header">
      <div class="page-hedaer">
        <h4 class="page-title">直播间列表</h4>
        <span class="title-info"
          >(针对直播间所有商品折扣一致，新手请查看<el-link
            type="primary"
            href="/#/tutorial"
            >使用教程</el-link
          >)</span
        >
      </div>
      <div class="actions">
        <el-select
          v-model="sort"
          size="small"
          style="width: 100px"
          @change="fetchList(1)"
        >
          <el-option label="比例最高" value="commissionRate_desc" />
          <el-option label="最新上架" value="expireTime_desc" />
        </el-select>
        <el-input
          v-model="q"
          placeholder="品牌、直播间名称"
          clearable
          size="small"
          style="width: 260px"
          @keyup.enter.native="fetchList(1)"
        />
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="fetchList(1)"
          >查询</el-button
        >
      </div>
    </div>

    <div v-loading="loading" class="goods-grid">
      <el-empty
        v-if="items.length === 0 && !loading"
        description="暂无商品"
      ></el-empty>
      <el-row :gutter="16">
        <el-col
          v-for="item in items"
          :key="item.id"
          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <goods :item="item"></goods>
        </el-col>
      </el-row>
    </div>

    <div class="pager" v-if="total > 0">
      <el-pagination
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="[12, 24, 48]"
        @current-change="fetchList"
        @size-change="onSizeChange"
      />
    </div>
  </el-card>
</template>

<script>
import api from "../../api";
import goods from "@/components/goods.vue";

export default {
  name: "Products",
  components: {
    goods,
  },
  data() {
    return {
      loading: false,
      q: "",
      items: [],
      total: 0,
      page: 1,
      pageSize: 12,
      sort: "commissionRate_desc",
    };
  },
  created() {
    this.fetchList(1);
  },
  methods: {
    async fetchList(page) {
      this.page = page;
      this.loading = true;
      try {
        const { data } = await api.get("/api/goods", {
          params: {
            q: this.q || undefined,
            page: this.page,
            page_size: this.pageSize,
            is_token_expired: 0,
            sort_by: this.sort.split("_")[0],
            sort_order: this.sort.split("_")[1],
          },
        });

        this.items = (data.items || []).map((x) => {
          console.log( (new Date(x.expireTime) - Date.now()) < 1000 * 60 * 60 * 6,)
          return {
            ...x,
            isRed: (new Date(x.expireTime) - Date.now()) < 1000 * 60 * 60 * 6,
          };
        });
        console.log(this.items )
        this.total = data.total || 0;
      } catch (e) {
        this.$message.error(e?.userMessage || "加载商品失败");
      } finally {
        this.loading = false;
      }
    },
    onSizeChange(size) {
      this.pageSize = size;
      this.fetchList(1);
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.page-hedaer {
  display: flex;
  align-items: center;
}
.page-title {
  margin: 0;
}
.title-info {
  margin-left: 5px;
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
}
.actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}
.goods-grid {
  min-height: 716px;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
</style>
